module.exports = __webpack_public_path__ + "img/velvet.437ddbad.png";